<script setup lang="ts">
    const emit = defineEmits(['localeChanged']);
    const localeSubmenu = ref(null);
    const translation = useTranslation();
    const availableLocales = useAvailableLocalesByCountry();

    const props = withDefaults(
        defineProps<{
            submenuPosition: string;
        }>(),
        {
            submenuPosition: 'right-0',
        }
    );

    const changeLocale = (locale: string) => {
        useSetLocale(locale);
        localeSubmenu.value?.hide();
        emit('localeChanged', locale);
    };
</script>

<template>
    <Submenu
        ref="localeSubmenu"
        :position="submenuPosition"
    >
        <template #default="slotProps">
            <slot
                :hide="slotProps.hide"
                :show="slotProps.show"
                :toggle="slotProps.toggle"
                :is-displayed="slotProps.isDisplayed"
            ></slot>
        </template>
        <template #submenu>
            <div class="w-full min-w-[260px]">
                <div :class="$theme('submenu.items_container')">
                    <div
                        v-for="(locales, country) in availableLocales"
                        :key="`language-switcher-country-${country}`"
                        :class="$theme('submenu.items')"
                    >
                        <a
                            v-for="availableLocale in locales"
                            :key="availableLocale.locale"
                            href="#"
                            :class="$theme('submenu.item_without_icon', 'flex items-center justify-between')"
                            @click.prevent="changeLocale(availableLocale.locale)"
                        >
                            <div class="flex items-center space-x-2">
                                <img
                                    class="h-[16px] bg-neutral-100 min-w-[18px]"
                                    :src="`https://trustup-io-shared-assets.ams3.cdn.digitaloceanspaces.com/images/translations/flags/${country}.svg`"
                                    alt=""
                                />
                                <span>
                                    {{ $t(`locales.native.${availableLocale.language}`) }}
                                </span>
                            </div>
                            <span>
                                <i
                                    v-if="availableLocale.locale === translation.getCurrentLocale()"
                                    class="text-sm fa-regular fa-circle-check"
                                    :class="$theme('submenu.item_icon')"
                                />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </Submenu>
</template>
